import { getActiveZones } from "./index23.js";
const pipeClearZone = ([parent, { aggProps }]) => {
	const zones = getActiveZones(parent, aggProps);
	for (const zone of zones) zone.children.length = 0;
	return [parent, void 0];
};
export { pipeClearZone };

//# sourceMappingURL=index175.js.map